/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';

//Actions
import { GetAllDevicesNoPagination } from '../../actions/deviceActions';    
import { getALLResidentsByCommunityID} from '../../actions/residentActions';
import { getRoomItemsByCommunityId, newroom } from '../../actions/roomAction';
import { getItemsByCommunity } from '../../actions/itemAction';
import { getIssuesByCommunity} from '../../actions/issueAction.js';
import { addWorkOrder} from '../../actions/WorkOrderAction.js'

//HeaderButtons
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
//material
import AppBar from "@material-ui/core/AppBar";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import { InputAdornment, TextField } from "@material-ui/core";

//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortAlphaDown, faSortAlphaUpAlt, faSort, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import FasSearch from '../../assets/svgs/solid/search' // assets/svgs/solid/search




const validate = (values) => {
    let errors={};
    return errors;
};


class AddRepairView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomSelected:undefined,
            itemSelected:undefined,
            issueSelected:undefined,
            residencySelected:undefined,
            isCommonArea:true,
            notifyResidentViaeHub: true,
            sortByNameAsc:undefined,
            sortByApartmentAsc:undefined,
            searchOpenedValue: undefined,
            searchRoomValue: undefined,
            sortByAreaNameAsc: undefined,
        };
    }

    componentDidMount(){
        const communityId = localStorage.getItem('communityId')
        this.props.getALLResidentsByCommunityID(communityId);
        this.props.getRoomItemsByCommunityId(communityId);
        this.props.getItemsByCommunity(communityId);
        this.props.getIssuesByCommunity(communityId)
        this.props.GetAllDevicesNoPagination(communityId);

        this.SetHeaderButtons();
    }
   
    //Header Buttons
    SetHeaderButtons = (options) => {
        const headerButtons = this.getHeaderButtons(options);
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = (options) => {
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <div style={styles.globalActions}>
                <Grid id='Repairs_Schedule_btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" 
                    style={
                            {
                                width: '154px', 
                                borderRadius: '19px', 
                                marginRight: '15px',  
                            }
                        }
                    onClick={() => this.CancelRepairRequest()}
                >
                    Cancel
                </Grid>
                <Grid id='Repairs_AddRepairrequest_btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" 
                    style={
                        { 
                            width: '200px', 
                            borderRadius: '19px', 
                            marginRight: '15px',  
                            opacity: (options && options.enableSubmit)? '100%':'32%',
                            cursor: (options && options.enableSubmit)? 'pointer':'not-allowed' 
                        }
                    }
                    onClick={(options && options.enableSubmit)?  () => this.SubmitRepairRequest(): undefined }
                >
                    Submit
                </Grid>
            </div>
        )
    }

    //#region Methods
    CancelRepairRequest = () =>{
        try{
            if(this.props.onCancel){
                this.props.onCancel()
            }
            return undefined;
        }catch(err){
            return undefined;
        }
    }

    SubmitRepairRequest = async () =>{
        try{
            const residencySelected = this.state.residencySelected? this.state.residencySelected : undefined;
            const roomSelected = this.state.roomSelected? this.state.roomSelected : undefined;
            const itemSelected = this.state.itemSelected? this.state.itemSelected : undefined;
            const issueSelected = this.state.issueSelected? this.state.issueSelected : undefined;

            if((!this.state.isCommonArea && !residencySelected)  || !roomSelected || !itemSelected || ! issueSelected || !this.props.addWorkOrder)
                return undefined;

            const repairRequestToSend={
                    room : {
                        _id: (roomSelected && roomSelected._id)? roomSelected._id : undefined,
                        name: (roomSelected && roomSelected.name)? String(roomSelected.name).trim() : undefined
                    },
                    item: {
                        _id: (itemSelected && itemSelected._id)? itemSelected._id : undefined,
                        name: (itemSelected && itemSelected.name)? String(itemSelected.name).trim() : undefined,
                        iconUrl: (itemSelected && itemSelected.iconUrl)? itemSelected.iconUrl : undefined
                    },
                    issue: {
                        _id: (issueSelected && issueSelected._id)? issueSelected._id : undefined,
                        name: (issueSelected && issueSelected.name)? String(issueSelected.name).trim() :undefined
                        }
            }

            const communityId = localStorage.getItem('communityId');
            const residentId= (!this.state.isCommonArea &&  residencySelected && residencySelected._id)? residencySelected._id : undefined; 

            const deviceObj= (!this.state.isCommonArea &&  residencySelected && residencySelected.deviceId &&this.props.deviceData && this.props.deviceData.length > 0)? this.props.deviceData.find(d => d._id === residencySelected.deviceId): undefined;
            const deviceId = (deviceObj && deviceObj._id)? deviceObj._id : undefined;
            const notifyResident=(!this.state.isCommonArea && this.state.notifyResidentViaeHub)? this.state.notifyResidentViaeHub : false;

            if(!repairRequestToSend || !communityId || (!this.state.isCommonArea && !residentId))
                return undefined;

            const objStyles = {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'};

            const res = await this.props.addWorkOrder(repairRequestToSend, communityId,residentId,deviceId,notifyResident,this.state.isCommonArea, objStyles);
            if(this.props.onCancel){
                this.props.onCancel()
            }


        }catch(err){
            return undefined;
        }
    }

    SortResidenciesList= (residenciesList) =>{
        try{
            let newList = residenciesList.map(r => r);            

            const includeApartmentSorting = (this.state.sortByApartmentAsc && (this.state.sortByApartmentAsc === 'true' || this.state.sortByApartmentAsc === 'false'))? true: false;
            const includeFullNameSorting= (this.state.sortByNameAsc && (this.state.sortByNameAsc === 'true' || this.state.sortByNameAsc === 'false'))? true: false;;

            const caseScenario = (includeApartmentSorting && includeFullNameSorting)? 1: (includeApartmentSorting)? 2 : (includeFullNameSorting)? 3: 4;

            newList.sort((a, b) =>{

                const conditionApartment = (this.state.sortByApartmentAsc && this.state.sortByApartmentAsc === 'true')? String(a.apartment) > String(b.apartment): (this.state.sortByApartmentAsc && this.state.sortByApartmentAsc === 'false')? String(a.apartment) < String(b.apartment): undefined;
                const conditionFullName = (this.state.sortByNameAsc && this.state.sortByNameAsc === 'true')? String(a.fullName) > String(b.fullName): (this.state.sortByNameAsc && this.state.sortByNameAsc === 'false')? String(a.fullName) < String(b.fullName): undefined;

                switch(caseScenario){
                    case 1:
                        if(conditionApartment){
                            if(conditionFullName){
                                return 1
                            }else if(String(a.fullName) === String(b.fullName)){
                                return 0;
                            }else{
                                return -1
                            }
                        }else if(String(a.apartment) === String(b.apartment)){
                            if(conditionFullName){
                                return 1
                            }else if(String(a.fullName) === String(b.fullName)){
                                return 0;
                            }else{
                                return -1
                            }
                        }else{
                            if(conditionFullName){
                                return 1
                            }else if(String(a.fullName) === String(b.fullName)){
                                return 0;
                            }else{
                                return -1
                            }
                        }
                    case 2:
                        if(conditionApartment){
                            return 1
                        }else if(String(a.apartment) === String(b.apartment)){
                            return 0;
                        }else{
                            return -1
                        }
                    case 3:
                        if(conditionFullName){
                            return 1
                        }else if(String(a.fullName) === String(b.fullName)){
                            return 0;
                        }else{
                            return -1
                        }
                    default:
                        if(String(a.apartment) > String(b.apartment)){
                            return 1
                        }else if(String(a.apartment) === String(b.apartment)){
                            return 0;
                        }else{
                            return -1
                        }
                }
            } )
            return newList
        }catch(err){
            return [];
        }
    }

    // GetResidenciesListProps = (residentListProps) =>{
    //     try{
    //         let newResidenciesListProps = [];
    //         newResidenciesListProps = (residentListProps && residentListProps.length > 0)? 
    //                                     residentListProps.map( r =>
    //                                         {
    //                                             const apartment = (r.zoneName)? r.zoneName.toLowerCase() : '';
    //                                             const firstName = (r.firstName)? r.firstName.charAt(0).toUpperCase() + r.firstName.slice(1).toLowerCase() : '';
    //                                             const lastName = (r.lastName)? r.lastName.charAt(0).toUpperCase() + r.lastName.slice(1).toLowerCase() : '';
    //                                             return {
    //                                                 _id: r._id,
    //                                                 apartment: apartment,
    //                                                 name: firstName,
    //                                                 lastName: lastName,
    //                                                 fullName: `${firstName} ${lastName}`,
    //                                                 fullInfo: `${apartment} ${firstName} ${lastName}`
    //                                             }
    //                                         }
    //                                     ) 
    //                                     :
    //                                     [];

    //         if(this.state.searchOpenedValue && this.state.searchOpenedValue.length > 0)
    //             newResidenciesListProps = newResidenciesListProps.filter(r => r.fullInfo.toLowerCase().includes(this.state.searchOpenedValue.toLowerCase()));

    //             newResidenciesListProps = this.SortResidenciesList(newResidenciesListProps);
    //         return newResidenciesListProps;

    //     }catch(err){
    //         return [];
    //     }
    // }

    GetResidenciesListProps = (originalResidentListProps) =>{
        try{

            let residentListProps = [];
            const deviceData = (this.props.deviceData && this.props.deviceData.length > 0)? this.props.deviceData : [];

            for(let i =0;i< originalResidentListProps.length; i++){
                const currentResident= originalResidentListProps[i];                

                const devicesForCurrentResident = (deviceData && deviceData.length)? deviceData.filter(d => String(d.residentId) === String(currentResident._id)): []

                if(devicesForCurrentResident && devicesForCurrentResident.length >0){

                    for(let j=0; j< devicesForCurrentResident.length; j++){
                        const newResidentCurrentDevice = JSON.parse(JSON.stringify(currentResident));
                        const currentDevice =devicesForCurrentResident[j];
    
                        if(!currentDevice) continue;
                        const serialNumberCurrentDevice = currentDevice.serial? currentDevice.serial : currentDevice._id? currentDevice._id : undefined
    
                        newResidentCurrentDevice.currentDeviceId = currentDevice._id
                        newResidentCurrentDevice.currentDevice = serialNumberCurrentDevice;

                        residentListProps.push(newResidentCurrentDevice);
                    }
                }else{
                    const newResidentCurrentDevice = JSON.parse(JSON.stringify(currentResident));
                    newResidentCurrentDevice.currentDeviceId =  undefined;
                    newResidentCurrentDevice.currentDevice =  undefined;

                    residentListProps.push(newResidentCurrentDevice);
                }
            }

            let newResidenciesListProps = [];
            newResidenciesListProps = (residentListProps && residentListProps.length > 0)? 
                                        residentListProps.map( r =>
                                            {
                                                const apartment = (r.zoneName)? r.zoneName.toLowerCase() : '';
                                                const firstName = (r.firstName)? r.firstName.charAt(0).toUpperCase() + r.firstName.slice(1).toLowerCase() : '';
                                                const lastName = (r.lastName)? r.lastName.charAt(0).toUpperCase() + r.lastName.slice(1).toLowerCase() : '';
                                                const currentDevice = (r.currentDevice)? r.currentDevice : undefined;
                                                const currentDeviceId= (r.currentDeviceId)? r.currentDeviceId : undefined;

                                                return {
                                                    _id: r._id,
                                                    apartment: apartment,
                                                    name: firstName,
                                                    lastName: lastName,
                                                    fullName: `${firstName} ${lastName}`,
                                                    fullInfo: `${apartment} ${firstName} ${lastName}`,
                                                    deviceId: currentDeviceId,
                                                    serial: currentDevice,
                                                }
                                            }
                                        ) 
                                        :
                                        [];

            if(this.state.searchOpenedValue && this.state.searchOpenedValue.length > 0)
                newResidenciesListProps = newResidenciesListProps.filter(r => r.fullInfo.toLowerCase().includes(this.state.searchOpenedValue.toLowerCase()));

                newResidenciesListProps = this.SortResidenciesList(newResidenciesListProps);

            return newResidenciesListProps;

        }catch(err){
            return [];
        }
    }

    GetRoomListProps = (roomListProp) =>{
        try{
            let newRoomList = (roomListProp && roomListProp.length > 0)? roomListProp : [];

            newRoomList.forEach(r => {
                let base = r.name.split(/[\s]/);

                let newName = '';
                for(let i =0;i< base.length; i++){
                    let  n = base[i];
                    n = (n && n.length > 0)?  n.charAt(0).toUpperCase() + n.slice(1).toLowerCase() :'';
                    newName = `${newName} ${n}`
                }
                r.name = newName;
            });

            newRoomList = newRoomList.sort((a,b) =>{
                const roomSorting = (!this.state.isCommonArea)? a.name > b.name : (this.state.sortByAreaNameAsc && this.state.sortByAreaNameAsc ==='false')? a.name < b.name: a.name > b.name
                if(roomSorting)
                    return 1
                if(a.name === b.name)
                    return 0 

                return -1;
            })

            if(this.state.isCommonArea && this.state.searchRoomValue && this.state.searchRoomValue.length > 0){
                newRoomList = newRoomList.filter(r => r.name.toLowerCase().includes(this.state.searchRoomValue.toLowerCase()))
            }

            if(this.state.isCommonArea){
                newRoomList = newRoomList.filter(r => r.isCommonRoom ===true)
            }else{
                newRoomList = newRoomList.filter(r => (!r.isCommonRoom || r.isCommonRoom ===false ))
            }

            return newRoomList
        }catch(err){
            return [];
        }
    }

    GetItemListProps = (itemList) =>{
        try{
            let newItemList = (itemList && itemList.length > 0)? itemList : [];
            newItemList.forEach(r => {
                let base = r.name.split(/[\s]/);

                let newName = '';
                for(let i =0;i< base.length; i++){
                    let  n = base[i];
                    n = (n && n.length > 0)?  n.charAt(0).toUpperCase() + n.slice(1).toLowerCase() :'';
                    newName = `${newName} ${n}`
                }
                r.name = newName.trim();
            });

            newItemList = newItemList.sort((a,b) =>{
                if(a.name > b.name)
                    return 1
                if(a.name === b.name)
                    return 0 

                return -1;
            });


            //check if roomSelected have items
            const itemsInRoomSelected = (this.state.roomSelected && this.state.roomSelected.items)? this.state.roomSelected.items : undefined;
            const itemsInRoomSelectedIds = itemsInRoomSelected.map(i => i._id);

            //filter items by room Selected
            newItemList = newItemList.filter(i => itemsInRoomSelectedIds.includes(i._id))
            return newItemList
        }catch(err){
            return [];
        }
    }

    GetIssueListProps = (issuesList) =>{
        try{
            let newIssueList = (issuesList && issuesList.length > 0)? issuesList : [];
            newIssueList.forEach(r => {
                let base = r.name.split(/[\s]/);

                let newName = '';
                for(let i =0;i< base.length; i++){
                    let  n = base[i];
                    n = (n && n.length > 0)?  n.charAt(0).toUpperCase() + n.slice(1).toLowerCase() :'';
                    newName = `${newName} ${n}`
                }
                r.name = newName.trim();
            });

            newIssueList = newIssueList.sort((a,b) =>{
                if(a.name > b.name)
                    return 1
                if(a.name === b.name)
                    return 0 

                return -1;
            });

            const itemSelected = this.state.itemSelected? this.state.itemSelected : undefined;

            newIssueList = newIssueList.filter(i => i.items.includes(itemSelected._id))
            const issuesInItemSelected =(this.state.itemSelected && this.state.itemSelected.issues)? this.state.itemSelected.issues : []

            return newIssueList
        }catch(err){
            return [];
        }
    }
    //#endregion

    //#region Inner Components
    SectionContainer = ({children}) =>{
        return(
            <Grid item container xs={12} className='LSectionInfoContainer'>
                {children}
            </Grid>
        )
    }

    AreaComponent= ({residenciesList, roomList}) =>{
        const style={
            container:{
                color:'#a5a3a4',
                fontSize:'18px',
                height:'100%',
            }
        }

        return(
            <Grid  item container xs={12} justifyContent='center' alignContent="flex-start" style={style.container}>          
                <Grid  item container xs={12} justifyContent='center' alignContent="center" style={{height:'5%'}}>
                    <Grid item container xs={2} justifyContent='center' alignContent="center">
                        <Grid item>
                            <Radio 
                                disableRipple={true}
                                disableFocusRipple={true}
                                checked={this.state.isCommonArea}
                                onChange={() => 
                                    {
                                        this.setState({isCommonArea: true, residencySelected: undefined, roomSelected:undefined, itemSelected:undefined, issueSelected:undefined, sortByApartmentAsc:undefined, sortByNameAsc:undefined, searchOpenedValue:undefined, searchRoomValue:undefined})
                                        this.SetHeaderButtons({enableSubmit:false});

                                        if(this.props.onEnableSubmit){
                                            this.props.onEnableSubmit(false);
                                        }
                                    }
                                } 
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={10} justifyContent='flex-start' alignContent="center">
                        <Grid item>
                            {'Common Area'}
                        </Grid>
                    </Grid>
                </Grid>
                {
                    (this.state.isCommonArea)?
                    <Grid item container xs={12} 
                        justifyContent='center' 
                        alignContent="flex-start" 
                        style={{maxHeight:'90%',  padding:'10x 0px', paddingLeft:'50px'}}
                    >
                        <Grid item container xs={11}>
                            <this.RoomsComponent roomList={roomList}/>
                        </Grid>
                    </Grid>
                    :
                    undefined
                }
                <Grid  item container xs={12} justifyContent='center' alignContent="center" style={{height:'5%'}}>
                    <Grid  item  container xs={2} justifyContent='center' alignContent="center">
                        <Grid item>
                            <Radio 
                                disableRipple={true}
                                disableFocusRipple={true}
                                checked={!this.state.isCommonArea}
                                onChange={() => 
                                    {
                                        this.setState({isCommonArea: false, residencySelected: undefined, roomSelected:undefined, itemSelected:undefined, issueSelected:undefined, sortByApartmentAsc:undefined, sortByNameAsc:undefined, searchOpenedValue:undefined, searchRoomValue:undefined});
                                        this.SetHeaderButtons({enableSubmit:false});

                                        if(this.props.onEnableSubmit){
                                            this.props.onEnableSubmit(false);
                                        }
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid  item  container xs={10} justifyContent='flex-start' alignContent="center">
                        <Grid item>
                            {'Residency'}
                        </Grid>
                    </Grid>
                </Grid>
                {
                    (!this.state.isCommonArea)?
                    <Grid  item container xs={12} 
                        justifyContent='center' 
                        alignContent="flex-start" 
                        style={{height:'90%', padding:'10x 0px', paddingLeft:'50px',paddingTop:'10px'}} 
                    >
                        <this.ResidencyComponent residenciesList={residenciesList}/>
                    </Grid>
                    :
                    undefined
                }
            </Grid>
        )
    }

    ResidencyComponent = ({residenciesList}) =>{
        return(
            <Grid  item  container xs={12} md={11} justifyContent='center' alignContent="flex-start" style={{height:'100%'}}>
                <Grid container xs={12} style={{}}>
                    <this.SearchResidency/>
                </Grid>
                <Grid container xs={12} style={{height:'10%'}} justifyContent='center' alignContent="center">
                    <this.ResidencyListHeaders/>
                </Grid>
                <Grid  item container xs={12} style={{}}>
                    <this.ResidencyList residenciesList={residenciesList}/>
                </Grid>
                <Grid  item  container xs={12} style={{}}>
                    <Grid  item  container xs={12}>
                        <Grid item container xs={2} justifyContent="center" alignContent="center">
                            <Grid item className="CheckboxBlue">
                                <Checkbox
                                    id={`NotifyResdientCheckBox`}
                                    checked={this.state.notifyResidentViaeHub}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() => this.setState( (prev) =>({notifyResidentViaeHub: !prev.notifyResidentViaeHub}))}
                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                    checkedIcon={
                                        <CheckBoxIcon fontSize="large" />
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid item container xs={10} justifyContent="center" alignContent="center">
                            <Grid item style={{fontSize:'15px', color:'#707070'}}>
                                Notify resident of repair request via eHub
                            </Grid>
                        </Grid>                                
                    </Grid>
                </Grid>
            </Grid>
            )
    }


    RoomsComponent= ({roomList}) =>{
        const style={
            container:{
                color:'#a5a3a4',
                fontSize:'18px',
                height:'100%',
                overflow:'auto',
                padding:'15px 0px',
            }
        }

        return(
            <Grid item container xs={12} justifyContent="center" alignContent="flex-start" style={style.container}>
                {
                    (this.state.isCommonArea)?
                    <>
                        <Grid item container xs={12} style={{padding:'5px 0px'}} justifyContent='center' alignContent="center">
                            <this.SearchInRooms/>
                        </Grid>
                        <Grid item container xs={12} style={{padding:'5px 0px'}} justifyContent='center' alignContent="center">
                            <this.SortingRooms/>
                        </Grid>
                    </>
                    :
                    undefined

                }
                {
                    (roomList && roomList.length > 0 && (this.state.isCommonArea || this.state.residencySelected))?
                    roomList.map((r, index) => <this.SingleRoom key ={`singleRoom_${r._id}`} room= {r} index={index}/>)
                    :
                    (!this.state.isCommonArea)?
                    <Grid item container xs={12} justifyContent='center' alignContent="center"  style={ style.container}>
                        <Grid item>
                            Please select a residency
                        </Grid>
                    </Grid>
                    :
                    undefined
                }
            </Grid>
        )
    }


    SearchInRooms = () =>{
        return (
            <Grid item container xs={12}>
                <Grid item xs={12}>
                    <TextField
                        id='opened_repairs_search'
                        name='Search'
                        placeholder="Search"
                        value={this.state.searchRoomValue? this.state.searchRoomValue : ''}
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                            classes:{
                                input:'LInputClasses'                                
                            },
                            startAdornment: (
                                <InputAdornment position="start" style={{paddingLeft:'10px'}}>
                                    {/* <img
                                        className=""
                                        src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                        alt='search_icon'
                                        width='32px'
                                        height='32px'
                                    /> */}
                                    <FasSearch className='LSearchAdornment'/>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton id='activities_clear_btn' onClick={() => this.setState({searchRoomValue: undefined})}>
                                        <FontAwesomeIcon icon={faTimesCircle} color='#707070' size='sm' />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        className="LActivities_search"
                        onChange={(e) => this.setState({ searchRoomValue: e.target.value })}
                    />
                </Grid>
            </Grid>
        )
    }

    SortingRooms = () =>{
        return (
            <Grid item container xs={12}>
                <Grid item container xs={12}>
                    <Grid  item container xs={2}></Grid>
                    <Grid  item container xs={5}>
                        <Grid  item container xs={8} justifyContent='center' alignContent="center">
                            <Grid item style={{color:'#707070'}}>
                                Common Area
                            </Grid>
                        </Grid>
                        <Grid  item container xs={4} 
                                onClick={() => this.setState((prev) => ({sortByAreaNameAsc: (prev.sortByAreaNameAsc && prev.sortByAreaNameAsc==='true')?'false':(prev.sortByAreaNameAsc && prev.sortByAreaNameAsc==='false')?undefined: 'true'}))} 
                                style={{cursor:'pointer'}}>
                            <this.SortingIcon state={this.state.sortByAreaNameAsc}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    SingleRoom = ({room, index}) =>{

        if(!room || !room._id )
            return <Grid item container xs={12}></Grid>

        const isChecked = (this.state.roomSelected &&  this.state.roomSelected._id)? this.state.roomSelected._id === room._id : false;

        const styles={
            evenRow:{
                color:'#707070'
            },
            oddRow:{
                backgroundColor:'#eeeeee',
                color:'#707070'
            }
        }        

        return (
            <Grid item container xs={12} style={(index && index%2)? styles.evenRow: styles.oddRow }>
                <Grid item container xs={2} justifyContent="center" alignContent="center">
                    <Grid item>
                        <Radio 
                            disableRipple={true} 
                            disableFocusRipple={true} 
                            checked={isChecked} 
                            onChange={() => 
                                {
                                    this.setState({roomSelected:room, itemSelected:undefined, issueSelected:undefined});
                                    this.SetHeaderButtons({enableSubmit:false});

                                    if(this.props.onEnableSubmit){
                                        this.props.onEnableSubmit(false);
                                    }
                                }
                            }
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={10}  justifyContent="flex-start" alignContent="center">
                    <Grid item>
                        {room && room.name? room.name : ''}
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    ItemsComponent= ({itemList}) =>{
        const style={
            container:{
                color:'#a5a3a4',
                fontSize:'18px',
                height:'100%',
                overflow:'auto',
                padding:'15px 0px'
            }
        }

        if(!itemList || itemList.length === 0)
            return (
                <Grid item container xs={12} md={11} justifyContent='center' alignContent="center"  style={ style.container}>
                    <Grid item>
                        No Items Found
                    </Grid>
                </Grid>
            ) 

        return(
            <Grid item container xs={12} justifyContent='center' alignContent="center">
                <Grid item container xs={12} md={11} justifyContent="flex-start" alignContent="flex-start" style={style.container}>
                    {
                        (itemList && itemList.length > 0)?
                        itemList.map((i, index) => 
                            <Grid item container key ={`singleItem_${i._id}`} xs={12} md={6}>
                                <this.SingleItem  item={i} index={index}/>
                            </Grid>
                        )
                        :
                        undefined
                    }
                </Grid>
            </Grid>
        )
    }

    SingleItem = ({item, index}) =>{
        const styles={
            container:{
                height:'120px',
                borderRadius:'9px',
                margin:'5px 0px',
                cursor:'pointer',
            },
            image:{
                height:'45px',
                width:'45px',
                filter:'invert(1)'
            },
            checkedItem:{
                backgroundColor:'#009EDD'
            },
            unCheckItem:{
                backgroundColor:'#eeeeee'                
            },
        }

        
        if(!item || !item._id )
            return <Grid item container xs={12}></Grid>

        const isChecked = (this.state.itemSelected &&  this.state.itemSelected._id)? this.state.itemSelected._id === item._id : false;

        return (
            <Grid item container xs={12} justifyContent='center' alignContent="center" style={{color:'#707070'}}>
                <Grid item container xs={11} 
                        style={(isChecked)? {...styles.container, ...styles.checkedItem}:  {...styles.container, ...styles.unCheckItem}} 
                        onClick={() => 
                            {
                                this.setState({itemSelected:item, issueSelected:undefined})
                                this.SetHeaderButtons({enableSubmit:false});

                                if(this.props.onEnableSubmit){
                                    this.props.onEnableSubmit(false);
                                }
                            }
                        }
                >
                    <Grid item container xs={12} justifyContent='center' alignContent="center"  style={{height:'80%'}}>
                        <Grid item>
                            {
                                (item.iconUrl)?
                                <img
                                    alt="icon"
                                    src={item.iconUrl}
                                    style={styles.image}
                                />
                                :
                                undefined
                            }
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} justifyContent='center' alignContent="center"  style={{height:'20%', overflow:'hidden'}}>
                        <Grid item>
                            {item.name}
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Grid item container xs={2} justifyContent="center" alignContent="center">
                    <Grid item>
                        <Radio 
                            disableRipple={true} 
                            disableFocusRipple={true} 
                            checked={isChecked} 
                            onChange={() => this.setState({itemSelected:item, issueSelected:undefined})}
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={10}  justifyContent="flex-start" alignContent="center">
                    <Grid item>
                        {item && item.name? item.name : ''}
                    </Grid>
                </Grid> */}
            </Grid>
        )
    }

    IssuesComponent= ({issueList}) =>{
        const style={
            container:{
                color:'#a5a3a4',
                fontSize:'18px',
                height:'100%',
                overflow:'auto',
                padding:'15px 0px'
            }
        }

        if(!issueList || issueList.length === 0)
            return (
                <Grid item container xs={12} justifyContent='center' alignContent="center"  style={ style.container}>
                    <Grid item>
                        No Issues Found
                    </Grid>
                </Grid>
            ) 

        return(
            <Grid item container xs={12} justifyContent="center" alignContent="flex-start" style={style.container}>
                {
                    (issueList && issueList.length > 0)?
                    issueList.map((i, index) => <this.SingleIssue key ={`singleIssue_${i._id}`} issue= {i} index={index}/>)
                    :
                    undefined
                }
            </Grid>
        )
    }

    SingleIssue = ({issue, index}) =>{
        if(!issue || !issue._id )
        return <Grid item container xs={12}></Grid>

    const isChecked = (this.state.issueSelected &&  this.state.issueSelected._id)? this.state.issueSelected._id === issue._id : false;

    const styles={
        evenRow:{
            color:'#707070'
        },
        oddRow:{
            backgroundColor:'#eeeeee',
            color:'#707070'
        }
    }

    return (
        <Grid item container xs={12} style={(index && index%2)? styles.evenRow: styles.oddRow}>
            <Grid item container xs={2} justifyContent="center" alignContent="center">
                <Grid item>
                    <Radio 
                        disableRipple={true} 
                        disableFocusRipple={true} 
                        checked={isChecked} 
                        onChange={() => {
                            this.SetHeaderButtons( {enableSubmit: true});
                            this.setState({issueSelected:issue}, () =>{
    
                                if(this.props.onEnableSubmit && this.state.issueSelected && this.state.itemSelected && this.state.roomSelected){
                                    this.props.onEnableSubmit(true);
                                }
                            });

                        }}
                    />
                </Grid>
            </Grid>
            <Grid item container xs={10}  justifyContent="flex-start" alignContent="center">
                <Grid item>
                    {issue && issue.name? issue.name : ''}
                </Grid>
            </Grid>
        </Grid>
    )
    }

    SearchResidency = () =>{
        return (
            <Grid item container xs={12} style={{ height:'100%'}}>
                <Grid item xs={12}>
                    <TextField
                        id='opened_repairs_search'
                        item
                        name='Search'
                        placeholder="Search by Apt or Resident"
                        value={this.state.searchOpenedValue? this.state.searchOpenedValue : ''}
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                            classes:{
                                input:'LInputClasses'                                
                            },
                            startAdornment: (
                                <InputAdornment position="start" style={{paddingLeft:'10px'}}>
                                    {/* <img
                                        src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                        alt='search_icon'
                                        width='32px'
                                        heigth='32px'
                                    /> */}
                                    <FasSearch className='LSearchAdornment'/>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton id='activities_clear_btn' onClick={() => this.setState({searchOpenedValue: undefined})}>
                                        <FontAwesomeIcon icon={faTimesCircle} color='#707070' size='sm' />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        className="LActivities_search"
                        onChange={(e) => this.setState({ searchOpenedValue: e.target.value })}
                    />
                </Grid>
            </Grid>
        )
    }

    ResidencyListHeaders = () =>{
        return(
            <Grid item container xs={12}>
                <Grid  item container xs={2}></Grid>
                <Grid  item container xs={5} style={{color:'#707070'}}>
                    <Grid  item container xs={8} justifyContent='center' alignContent="center">
                        <Grid item>
                            Apartment
                        </Grid>
                    </Grid>
                    <Grid  item container xs={4} 
                            onClick={() => this.setState((prev) => ({sortByApartmentAsc: (prev.sortByApartmentAsc && prev.sortByApartmentAsc==='true')?'false':(prev.sortByApartmentAsc && prev.sortByApartmentAsc==='false')?undefined: 'true', sortByNameAsc : undefined }))} 
                            style={{cursor:'pointer'}}>
                        <this.SortingIcon state={this.state.sortByApartmentAsc}/>
                    </Grid>
                </Grid>
                <Grid  item  container xs={5}>
                    <Grid  item container xs={8} justifyContent='center' alignContent="center">
                        <Grid item >
                            Name
                        </Grid>
                    </Grid>
                    <Grid  item container xs={4} 
                        onClick={() => this.setState((prev) => ({sortByNameAsc: (prev.sortByNameAsc && prev.sortByNameAsc==='true')?'false':(prev.sortByNameAsc && prev.sortByNameAsc==='false')?undefined: 'true',  sortByApartmentAsc : undefined }))}
                        style={{cursor:'pointer'}}>
                        <this.SortingIcon state={this.state.sortByNameAsc}/>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    SortingIcon= ({state}) =>{
        return(
            <Grid  item container sx={12}>
                <FontAwesomeIcon color="#707070" icon={
                    (state && state==='true')? 
                        faSortAlphaDown  
                    :
                        (state && state==='false')?  
                            faSortAlphaUpAlt
                            :
                            faSort
                    }
                />
            </Grid>
        )
    }

    ResidencyList = ({residenciesList}) =>{

        const styles ={
            residenciesList:{
                height:'100%',
                overflow:'auto',
            }
        }

        if(!residenciesList || residenciesList.length ===0)
            return <Grid  item  container xs={12}></Grid>

        return(
            <Grid  item  container xs={12} style={styles.residenciesList}  justifyContent='center' alignContent="flex-start">
                {
                    residenciesList.map((r, index) => <this.SingleResidency key ={`SingleResidency_${r._id}_${index}`} residency={r} index={index}/>)
                }
            </Grid>
        )
    }

    SingleResidency = ({residency, index}) =>{

        // const isChecked= (this.state.residencySelected && this.state.residencySelected._id)? this.state.residencySelected._id === residency._id: false;

        let isChecked = false;

        if(residency && residency._id && residency.deviceId){
            if(
                this.state.residencySelected && 
                this.state.residencySelected._id && 
                this.state.residencySelected.deviceId  && 
                residency._id === this.state.residencySelected._id && 
                residency.deviceId === this.state.residencySelected.deviceId
            ){
                isChecked =true;
            }
        }else if(residency && residency._id && !residency.deviceId){
            if(
                this.state.residencySelected && 
                this.state.residencySelected._id && 
                residency._id === this.state.residencySelected._id &&
                !this.state.residencySelected.deviceId
            ){
                isChecked =true;
            }
        }

        const styles={
            evenRow:{
                color:'#707070'
            },
            oddRow:{
                backgroundColor:'#eeeeee',
                color:'#707070'
            },
            serialStyles:{fontSize:'12px', paddingRight:'5px'},
        }        

        const serialNumber = (residency && residency.serial)? residency.serial : undefined;

        return(
            <Grid item container xs={12} justifyContent='center' alignContent="center" style={(index && index%2)? styles.evenRow: styles.oddRow}>
                <Grid  item container xs={2} justifyContent='center' alignContent="center">
                    <Grid item>
                        <Radio 
                            disableRipple={true} 
                            disableFocusRipple={true} 
                            checked={isChecked} 
                            onChange={() => this.setState({residencySelected:residency, roomSelected: undefined, itemSelected:undefined, issueSelected: undefined}, () =>{

                                if(this.props.onEnableSubmit){
                                    this.props.onEnableSubmit(false);
                                }
                            })}
                        />
                    </Grid>
                </Grid>
                <Grid  item container xs={5} justifyContent='flex-start' alignContent="center">
                    <Grid item>
                        {residency.apartment}
                    </Grid>
                </Grid>
                <Grid  item container xs={5}  justifyContent='flex-start' alignContent="center">
                    <Grid item container xs={12} justify='flex-start' alignContent="center">
                        <Grid item>
                            {`${residency.fullName}`}
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} justify='flex-end' alignContent="center" style={styles.serialStyles}>
                        {
                            serialNumber?
                            <Grid item>
                                {serialNumber}
                            </Grid>
                            :
                            undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    //#endregion

    render() {
        const styles={
            containerStyles:{
                padding:'10px',
                fontSize:'22px',
                height:'100%',
            },
            innerContainer:{
                height:'100%',
                padding:'10px'
            }
        }

        
        const residenciesListProps = this.GetResidenciesListProps(this.props.residentData);
        const roomListProps= this.GetRoomListProps(this.props.roomsData);
        const itemListProp = this.GetItemListProps(this.props.itemsData);
        const issueListProp = this.GetIssueListProps(this.props.issuesData);

        if(this.props.onSubmit && !this.state.submitCalled){
            this.setState({submitCalled: true},
                () =>{
                    this.SubmitRepairRequest()
                })
        }

        return (
            <>
            {/* Content */}
            <Grid item container xs={12} justifyContent='flex-start' alignContent="flex-start" style={{ height:'740px'}} >
                <Grid item container xs={12} md={4} lg={4}  justifyContent='center' alignContent="flex-start" style={styles.containerStyles}>
                    <Grid item container justifyContent="flex-start" alignContent="flex-end" style={{paddingLeft:'10px', height:'5%'}}>
                        <Grid item container xs={12}  className='LSectionTitle'>
                            Location
                        </Grid>
                    </Grid>
                    <Grid item container style={{height:'95%'}}>
                        <this.SectionContainer>
                            <this.AreaComponent residenciesList={residenciesListProps} roomList={roomListProps}/>
                        </this.SectionContainer>                    
                    </Grid>
                </Grid>
                {
                    (!this.state.isCommonArea)?
                    <Grid item container xs={12} md={4} lg={3} style={styles.containerStyles} justifyContent='center' alignContent="center">
                        <Grid item container xs={12} style={{paddingLeft:'10px', height:'5%'}}>
                            <Grid item container xs={12} className='LSectionTitle'>
                                Room
                            </Grid>
                        </Grid>
                        <Grid item container style={{height:'95%'}}>
                            <this.SectionContainer>
                                <Grid item container xs={12} justifyContent='center' alignContent='flex-start'>
                                    <Grid item container xs={11}>
                                        <this.RoomsComponent roomList={roomListProps}/>
                                    </Grid>
                                </Grid>
                            </this.SectionContainer>
                        </Grid>
                    </Grid>
                    :
                    undefined
                }
                <Grid item container xs={12} md={4} lg={3} style={styles.containerStyles} justifyContent='center' alignContent="center">
                    <Grid item container xs={12} style={{paddingLeft:'10px', height:'5%'}}>
                        <Grid item container xs={12} className='LSectionTitle'>
                            Item
                        </Grid>
                    </Grid>
                    <Grid item container style={{height:'95%'}}>
                        <this.SectionContainer>
                            <Grid item container xs={12} justifyContent='center' alignContent='flex-start'>
                                <Grid item container xs={11}>
                                    <this.ItemsComponent itemList= {itemListProp}/>
                                </Grid>
                            </Grid>                        
                        </this.SectionContainer>
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={4} lg={2} style={styles.containerStyles} justifyContent='center' alignContent="center">
                    <Grid item container xs={12} style={{paddingLeft:'10px', height:'5%'}}>
                        <Grid item container xs={12} className='LSectionTitle'>
                            Issue
                        </Grid>
                    </Grid>
                    <Grid item container style={{height:'95%'}}>
                        <this.SectionContainer>
                            <Grid item container xs={12} justifyContent='center' alignContent='flex-start'>
                                <Grid item container xs={11}>
                                    <this.IssuesComponent issueList = {issueListProp}/>
                                </Grid>
                            </Grid>
                        </this.SectionContainer>
                    </Grid>
                </Grid> 
            </Grid>
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : [];
    const roomsData = (state.roomReducer && state.roomReducer.roomItemData) ? state.roomReducer.roomItemData : [];
    const itemsData = (state.itemReducer && state.itemReducer.itemData) ? state.itemReducer.itemData : [];
    const issuesData = (state.issueReducer && state.issueReducer.issueData) ? state.issueReducer.issueData : [];
    const deviceData = (state.deviceReducer && state.deviceReducer.deviceData) ? [...state.deviceReducer.deviceData] : [];

    return {
        residentData: residentData,
        roomsData: roomsData,
        itemsData: itemsData,
        issuesData: issuesData,
        deviceData: deviceData,
    };
}

export default connect(mapStateToProps,{SetHeaderButtons, getALLResidentsByCommunityID, getRoomItemsByCommunityId, getItemsByCommunity, getIssuesByCommunity, addWorkOrder, GetAllDevicesNoPagination})(reduxForm({
    form: 'AddRepairForm',
})(AddRepairView));





